<template>
  <v-app>
    <v-navigation-drawer
      persistent
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <v-list>
        
        <v-list-tile to="/">
          <v-list-tile-action>
            <v-icon>account_balance_wallet</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Gastos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile to="/ahorro">
          <v-list-tile-action>
            <v-icon>account_balance</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Proyección de Ahorro</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      dark
      app
      color="accent">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>      
      <v-toolbar-title>{{titulo}}</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <router-view @setTitulo="setTitulo"/>
    </v-content>
    <v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
      app
    >
      <v-list>
        <v-list-tile @click="right = !right">
          <v-list-tile-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      fixed: false,
      right: true,
      rightDrawer: false,
      titulo: "Planificador"
    };
  },
  methods:{
    setTitulo(titulo){
      this.titulo = titulo
    }
  },
  name: "App"
};
</script>



// WEBPACK FOOTER //
// src/App.vue